import { Button } from "./styles";
import Loader from "../Loader";
interface ButtonProps {
  type?: "button" | "submit" | "reset";
  onClick?: () => void;
  children: any;
  disabled?: boolean;
  forwardref?;
  form?: any;
  loading?: boolean;
  options: {
    type: "filled" | "outline" | "link" | "common";
    size: "xs" | "sm" | "md" | "lg" | "xl";
    skin: "purple" | "transparent";
    block?: boolean;
  };
  styles?;
}

const Component = ({
  children,
  loading,
  forwardref,
  type = "button",
  ...rest
}: ButtonProps) => {
  return (
    <Button {...(forwardref && { ref: forwardref })} {...rest} type={type}>
      {loading ? <Loader /> : children}
    </Button>
  );
};

export default Component;
